import { pageEnhancer } from '@common/hoc/pageEnhancer';
import { handleGetStaticProps } from '@legacyApp/methods/router/handleGetStaticProps';
import { ROUTING_ID } from '@common/constants/routing/ids.routing.constants';
import AllTransactionsContainer from '../../LegacyApp/client/pages/allTransactions.page/allTransactions.container';

const id = ROUTING_ID.USER_ALL_TRANSACTIONS;

export async function getStaticProps(props) {
	return await handleGetStaticProps(props);
}

export default pageEnhancer(AllTransactionsContainer, {
	id,
	seoProps: {
		nofollow: true,
		noindex: true,
	},
});
